import React, { useEffect, useState, useRef } from "react";
import BookingDetailSidebar from "./components/detail-sidebar";
import BooingFurthurDetails from "./components/detail-table";
import { Icon } from "@iconify/react";
import { Formik } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../../components/ui/tabs";
import { useMediaQuery } from "../../../hooks";
import { cn } from "../../../helper/utilityHelper";
import {
  FormikInput,
  FormikSearchSectionSelect,
  FormikSelect,
  FormikSearchSelect,
  FormikSingleFileUpload,
  FormikDate,
  FormikTextArea,
  FormikRadio,
} from "../../../components/formik-components";
import { Button } from "../../../components/ui/button";
import DialogModal from "../../../components/partials/modal/dialogModal";
import AppConstant, {
  PaymentTypeEnum,
  RoleEnum,
  IntMinLevel,
  DateminFormat,
  respEnum,
  ToCSharpFormat,
  IntMax,
  BookingStatusEnum,
  PaymentStatusEnum,
  ImageFolderEnum,
  TransactionLogTypeEnum,
  BookingModeEnum,
  ClubBankDiscountTypeEnum,
  TaxTypeEnum,
} from "../../../constants/appConstant";
import Common from "../../../helper/common";
import {
  BreadcrumbItem,
  Breadcrumbs,
} from "../../../components/ui/breadcrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import { CardContent, CardHeader, Card } from "../../../components/ui/card";
import { useMenu } from "../../../contexts/menuContext";
import { useQueryParams } from "../../../contexts/queryParamsContext";
import { PrintReceipt } from "../../../components/print";
import { SendWhatsapp } from "../../../components/whatsapp";

const BooingDetails = () => {
  const location = useLocation();
  const isDesktop = useMediaQuery("(max-width: 1280px)");
  const [openEdit, setOpenEdit] = useState(false);
  const [booking, setBooking] = useState({});
  const [showSidebar, setShowSidebar] = useState(true);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [courtList, setCourtList] = useState([]);
  const [posMachines, setPosMachines] = useState([]);
  const [accountTypeById, setAccountTypeById] = useState({});
  const [clubDiscountList, setClubDiscountList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const navigate = useNavigate();
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showReschedule, setShowReschedule] = useState(false);
  const [showAddDiscount, setShowAddDiscount] = useState(false);
  const [ShowCancelBooking, setShowCancelBooking] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showAddTax, setShowAddTax] = useState(false);
  const [ispPaymentRecBtn, setDispPaymentRecBtn] = useState(true);
  const { setIsMenuVisible } = useMenu();
  const { bookingId } = useQueryParams().params;
  const [renderImageRecipt, setRenderImageRecipt] = useState(false);
  const [cancellationReasons, setCancellationReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);
  const [showOtherReason, setShowOtherReason] = useState(false);
  const formikRef = useRef();

  // Loading states for all actions
  const [isAddingPayment, setIsAddingPayment] = useState(false);
  const [isAddingDiscount, setIsAddingDiscount] = useState(false);
  const [isRescheduling, setIsRescheduling] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [isAddingNotes, setIsAddingNotes] = useState(false);
  const [isAddingTax, setIsAddingTax] = useState(false);
  //const [displayCharges, setDisplayCharges] = useState(false);
  //let funExecute = false;
  let courtChargesDisabled = true;

  useEffect(() => {
    setIsMenuVisible(false);
    if (bookingId) {
      getBookingDetails();
    }
    getClubPaymentTypes();
    getPOSMachinesDDL();
    getClubDiscountDDL();
    getCancellationReasons();
    getTaxList();
    return () => {
      setIsMenuVisible(true);
    };
  }, [bookingId]);

  useEffect(() => {
    if (showReschedule) {
      getCourts();
    }
  }, [showReschedule]);

  useEffect(() => {
    if (
      booking?.transactionLogs?.some(
        (tlog) =>
          tlog.transactionType !== TransactionLogTypeEnum.PromoCode_Redeemed &&
          tlog.transactionType !== TransactionLogTypeEnum.Club_Discount &&
          tlog.attachment
      )
    ) {
      setDispPaymentRecBtn(false);
    } else {
      setDispPaymentRecBtn(true);
    }
  }, [booking?.transactionLogs]);

  const formCancelValidations = yup.object({
    cancellationreasonid: yup
      .number()
      .nullable()
      .when([], {
        is: () => booking?.bookingMode === BookingModeEnum.App_Booking,
        then: (schema) =>
          schema.required("Cancellation reason is required for App Bookings"),
        otherwise: (schema) => schema.nullable().optional(),
      }),
    reason: yup.string().when("cancellationreasonid", {
      is: (val) => {
        const selectedReasonData = cancellationReasons.find(
          (r) => r.value === val
        );
        return selectedReasonData?.isOther === true;
      },
      then: (schema) =>
        schema.required("Please specify the reason").min(1).max(50),
      otherwise: (schema) => schema.optional(),
    }),
  });

  const formNotesValidations = yup.object({
    notes: yup
      .string()
      .trim()
      .min(1)
      .max(150)
      .required("Notes is Required Here"),
  });

  const formValidations = yup.object({
    clubAccountId: yup.object().required("Payment Account Required"),
    amount: yup
      .number()
      .required("Enter Amount")
      .min(IntMinLevel, "Amount can't be negative or zero")
      .max(
        booking?.remainingAmount,
        `Amount must be less ${booking?.remainingAmount}`
      )
      .test(
        "is-integer",
        "Please enter a whole number without decimal points",
        (value) => Number.isInteger(value)
      ),
  });

  const discountValidation = yup.object({
    discount: yup
      .number()
      .required("Enter Discount")
      .min(IntMinLevel, "Discount can't be negative or zero")
      .max(
        booking?.remainingAmount,
        `Discount must be less than ${booking?.remainingAmount}`
      )
      .test(
        "is-integer",
        "Please enter a whole number without decimal points",
        (value) => Number.isInteger(value)
      ),
  });

  const bankDiscountValidation = yup.object({
    discount: yup
      .number()
      .required("Enter Discount")
      .min(IntMinLevel, "Discount can't be negative or zero")
      .max(
        booking?.remainingAmount,
        `Discount must be less than ${booking?.remainingAmount}`
      )
      .test(
        "is-integer",
        "Please enter a whole number without decimal points",
        (value) => Number.isInteger(value)
      ),
    clubbankdiscountid: yup.number().required("Bank selection is required"),
  });

  // Dynamic validation schema that checks the discount tab
  const dynamicDiscountValidation = yup.object().shape({
    discount: yup
      .number()
      .required("Enter Discount")
      .min(IntMinLevel, "Discount can't be negative or zero")
      .max(
        booking?.remainingAmount,
        `Discount must be less than ${booking?.remainingAmount}`
      )
      .test(
        "is-integer",
        "Please enter a whole number without decimal points",
        (value) => Number.isInteger(value)
      ),
    clubbankdiscountid: yup.number().when("discountTab", {
      is: "card",
      then: (schema) => schema.required("Bank selection is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    discountTab: yup.string(),
    discountType: yup.string(),
    percentage: yup.string(),
  });

  const formRescheduleValidations = yup.object({
    courtId: yup.object().required("Court is Requied"),
    bookingDate: yup
      .date()
      .required("Booking Date is Requied")
      .min(
        new Date(new Date().setHours(0, 0, 0, 0)),
        "Date should not be earlier than today"
      ),
    startDateTime: yup
      .string()
      .required("Start Time is required")
      .test(
        "is-valid-time",
        "Start Time format should be in 00, 30 or 23:59 format",
        (value) => Common.Utility.CheckTime(value)
      )
      .matches(
        /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
        "Invalid time format (HH:mm)"
      ),

    endDateTime: yup
      .string()
      .required("End time is required")
      .test(
        "is-valid-time",
        "End Time format should be in 00, 30 23:59 format",
        (value) => Common.Utility.CheckTime(value)
      )
      .matches(
        /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
        "Invalid time format (HH:mm)"
      ),

    // Simple validation without conditional logic
    courtcharges: yup.number().optional(),
  });

  const handleEditSheetOpen = () => {
    setOpenEdit(!openEdit);
  };

  const getCourts = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetSportWiseCourtddl"
    );
    if (response?.status == respEnum.Success) {
      setCourtList(response?.data ?? []);
    }
  };

  const AddNotes = async (d) => {
    if (isAddingNotes) return; // Prevent multiple submissions

    setIsAddingNotes(true);
    try {
      let data = {
        ...d,
        bookingId: +booking?.id,
      };

      let resp = await Common.ApiService.getInstance().request(
        "AddUpdateBookingNotes",
        data,
        "Patch"
      );
      if (resp.status == respEnum.Success) {
        setShowNotes(false);
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getBookingDetails();
        }, 500);
      }
    } catch (error) {
      console.error("Error adding notes:", error);
    } finally {
      setIsAddingNotes(false);
    }
  };

  const cancelledBooking = async (d) => {
    if (isCancelling) return; // Prevent multiple submissions

    setIsCancelling(true);
    try {
      let data = {
        ...d,
        bookingId: +booking?.id,
        status: +BookingStatusEnum.Cancelled_By_Club,
        cancellationreasonid: d.cancellationreasonid || null,
      };

      // Always send reasonId if a reason is selected
      if (d.cancellationreasonid) {
        data.reasonId = d.cancellationreasonid;

        // Find the selected reason to check if it's "Other"
        const selectedReasonData = cancellationReasons.find(
          (r) => r.value === d.cancellationreasonid
        );

        // If it's an "Other" reason, send the text from the reason textbox
        if (selectedReasonData?.isOther && d.reason) {
          data.reason = d.reason;
        } else {
          // For non-"Other" reasons, send the reason label
          data.reason = selectedReasonData?.label || "";
        }
      }

      let resp = await Common.ApiService.getInstance().request(
        "UpdateBookingStatus",
        data,
        "Patch"
      );
      if (resp.status == respEnum.Success) {
        setShowCancelBooking(false);
        setSelectedReason(null);
        setShowOtherReason(false);
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getBookingDetails();
        }, 500);
      }
    } catch (error) {
      console.error("Error cancelling booking:", error);
    } finally {
      setIsCancelling(false);
    }
  };

  const getClubDiscountDDL = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubDiscountDDL"
    );

    if (response?.status == respEnum.Success) {
      if (response?.data?.length > 0) {
        setClubDiscountList([{ id: null, name: "Select" }, ...response?.data]);
      } else if (response?.data?.length == 0) {
        setClubDiscountList([]);
      }
    }
  };

  const getCancellationReasons = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetCancellationReasonDDL"
    );

    if (response?.status == respEnum.Success) {
      setCancellationReasons(response?.data || []);
    }
  };

  const getTaxList = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetTaxList"
    );
    if (response?.status == respEnum.Success) {
      setTaxList(response?.data ?? []);
    }
  };

  const calculateInclusiveTaxAmount = (courtcharges, taxPercentage) => {
    if (!courtcharges || !taxPercentage) return 0;
    const baseAmount = courtcharges / (1 + taxPercentage / 100);
    const taxAmount = courtcharges - baseAmount;
    return Math.round(taxAmount);
  };

  debugger
  const applyTax = async (d) => {
    if (isAddingTax) return;
    setIsAddingTax(true);
    try {
      const selectedTax = taxList.find(t => t.id === d.tax_id);
      if (!selectedTax) {
        toast.error("Please select a tax");
        setIsAddingTax(false);
        return;
      }

      const courtcharges = booking?.courtcharges || 0;
      const taxAmount = calculateInclusiveTaxAmount(
        courtcharges,
        selectedTax.percentage
      );

      const data = {
        booking_id: booking?.id,
        tax_id: d.tax_id,
        amount: taxAmount,
        percentage: selectedTax.percentage,
        type: selectedTax.type,
      };

      const response = await Common.ApiService.getInstance().request(
        "ApplyBookingTax",
        data,
        "POST"
      );

      if (response?.status == respEnum.Success) {
        setShowAddTax(false);
        Common.SweetAlert.alert(response.message, "success");
        setTimeout(() => {
          getBookingDetails();
        }, 500);
      } else {
        toast.error(response?.message || "Failed to apply tax");
      }
    } catch (error) {
      console.error("Error applying tax:", error);
      toast.error("An error occurred while applying tax");
    } finally {
      setIsAddingTax(false);
    }
  };

  const AddDiscount = async (d) => {
    if (isAddingDiscount) return; // Prevent multiple submissions

    setIsAddingDiscount(true);
    try {
      let resp;

      if (d.clubbankdiscountid) {
        // This is a bank discount

        // Find the selected card to get maxDiscount
        const selectedCardObj = clubDiscountList.find(
          (card) => card.id === d.clubbankdiscountid
        );

        // which discount to use based on cap logic
        let discountToUse;
        if (d.discountType === "fixed") {
          // For fixed amount, use the entered amount directly
          discountToUse = d.discount;
        } else {
          // For percentage, apply cap logic
          if (
            selectedCardObj?.maxDiscount &&
            d.originalDiscount > selectedCardObj.maxDiscount
          ) {
            // Original discount exceeds max, use final discount (capped)
            discountToUse = d.finalDiscount;
            console.log("discountToUse", d.finalDiscount);
          } else {
            // Original discount is within limit, use original discount
            discountToUse = d.originalDiscount;
            console.log("discountToUse", d.originalDiscount);
          }
        }
        let data = {
          ...d,
          bookingId: booking?.id,
          discount: +discountToUse,
          //originalDiscount: +d.originalDiscount,  // Include original for records
          //finalDiscount: +d.finalDiscount,        // Include final for records
          clubbankdiscountid: +d.clubbankdiscountid,
          posmachineid: d.posmachineid || null,
        };

        if (booking?.remainingAmount < data.discount) {
          toast.error(
            `Discount must be less then ${booking?.remainingAmount} Rs`
          );
          return;
        }

        if (d.files && d.files.filter((item) => !item.imageUrl).length) {
          var uploadFilePathType = ImageFolderEnum.transactions;
          data.receipt = (
            await Common.Utility.handleFileUpload(d.files, uploadFilePathType)
          )[0].photo;
          data.files = null;
        } else if (d.attachment) {
          data.receipt = d.attachment;
        }

        resp = await Common.ApiService.getInstance().request(
          "AddBankDiscountOnBooking",
          data,
          "POST"
        );
      } else {
        // This is a regular discount
        let data = {
          ...d,
          bookingId: booking?.id,
          discount: +d.discount,
          posmachineid: d.posmachineid || null,
        };

        if (booking?.remainingAmount < data.discount) {
          toast.error(
            `Discount must be less then ${booking?.remainingAmount} Rs`
          );
          return;
        }
        if (d.files && d.files.filter((item) => !item.imageUrl).length) {
          var uploadFilePathType = ImageFolderEnum.transactions;
          data.receipt = (
            await Common.Utility.handleFileUpload(d.files, uploadFilePathType)
          )[0].photo;
          data.files = null;
        } else if (d.attachment) {
          data.receipt = d.attachment;
        }

        resp = await Common.ApiService.getInstance().request(
          "AddBookingDiscount",
          data,
          "POST"
        );
      }

      if (resp.status == respEnum.Success) {
        setShowAddDiscount(false);
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getBookingDetails();
        }, 500);
      }
    } catch (error) {
      console.error("Error adding discount:", error);
    } finally {
      setIsAddingDiscount(false);
    }
  };

  const AddPayment = async (d) => {
    if (isAddingPayment) return; // Prevent multiple submissions

    setIsAddingPayment(true);
    try {
      if (d.files && d.files.filter((item) => !item.imageUrl).length) {
        var uploadFilePathType = !renderImageRecipt
          ? ImageFolderEnum.transactions
          : ImageFolderEnum.upload;
        d.attachment = (
          await Common.Utility.handleFileUpload(d.files, uploadFilePathType)
        )[0].photo;
        d.files = null;
      }
      let data = {
        ...d,
        bookingId: booking?.id,
        clubAccountId: d.clubAccountId?.value,
        posmachineid: d.posmachineid || null,
      };

      if (booking?.remainingAmount < data.amount) {
        toast.error(
          `Received amount must be less then ${booking?.remainingAmount} Rs`
        );
        return;
      }

      let resp = await Common.ApiService.getInstance().request(
        "AddBookingPayment",
        data,
        "POST"
      );
      if (resp.status == respEnum.Success) {
        setShowAddPayment(false);
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getBookingDetails();
        }, 500);
      }
    } catch (error) {
      console.error("Error adding payment:", error);
    } finally {
      setIsAddingPayment(false);
    }
  };

  const Reschedule = async (d) => {
    if (isRescheduling) return; // Prevent multiple submissions

    // Manual validation for court charges when duration changes
    if (booking.paymentStatus == PaymentStatusEnum.Un_Paid) {
      const bookingDate = dayjs(d.bookingDate).format("YYYY-MM-DD");
      const newStartDateTime = dayjs(
        `${bookingDate} ${d.startDateTime}`,
        "YYYY-MM-DD HH:mm"
      );
      const newEndDateTime = dayjs(
        `${bookingDate} ${d.endDateTime}`,
        "YYYY-MM-DD HH:mm"
      );

      const originalDuration = dayjs(booking?.endDateTime).diff(
        dayjs(booking?.startDateTime),
        "minute"
      );
      const newDuration = newEndDateTime.diff(newStartDateTime, "minute");

      const isDurationChanged =
        newDuration !== originalDuration - 1 &&
        newDuration !== originalDuration &&
        originalDuration !== newDuration - 1;

      // Manual validation for court charges when duration changes
      if (isDurationChanged) {
        if (!d.courtcharges || d.courtcharges === "" || d.courtcharges <= 0) {
          toast.error("New court charges are required when duration changes");
          return;
        }
        if (d.courtcharges > IntMax) {
          toast.error(`Court charges cannot be greater than ${IntMax}`);
          return;
        }
        if (!Number.isInteger(Number(d.courtcharges))) {
          toast.error("Please enter a whole number without decimal points");
          return;
        }
      }
    }

    setIsRescheduling(true);
    try {
      let data = {
        bookingId: booking?.id,
        courtId: d.courtId.value,
        newStartDateTime: Common.moment(
          `${d.bookingDate} ${d.startDateTime}`
        ).format(ToCSharpFormat),
        newEndDateTime: Common.moment(
          `${d.bookingDate} ${d.endDateTime}`
        ).format(ToCSharpFormat),
      };

      if (data.newStartDateTime >= data.newEndDateTime) {
        toast.error(`End time must be greater`);
        return;
      }

      const now = dayjs();
      if (
        dayjs(data.newStartDateTime).isBefore(now) ||
        dayjs(data.newEndDateTime).isBefore(now)
      ) {
        toast.error(`Start Time and End Time must not be in the past`);
        return;
      }

      if (data.courtId === booking.courtId) {
        if (
          data.newStartDateTime === booking.startDateTime &&
          data.newEndDateTime === booking.endDateTime
        ) {
          toast.error(
            "Rescheduling requires a change in either the start or end time"
          );
          return;
        }
      }

      const originalDuration = dayjs(booking?.endDateTime).diff(
        dayjs(booking?.startDateTime),
        "minute"
      );
      const newDuration = dayjs(data.newEndDateTime).diff(
        dayjs(data.newStartDateTime),
        "minute"
      );

      if (booking.paymentStatus != PaymentStatusEnum.Un_Paid) {
        if (
          newDuration != originalDuration - 1 &&
          newDuration != originalDuration &&
          originalDuration != newDuration - 1
        ) {
          toast.error(
            `The duration must be (${originalDuration} minutes) when payment status is ${Common.Utility.getKeyByValue(
              PaymentStatusEnum,
              booking.paymentStatus
            )} `
          );
          return;
        }
      }

      if (
        booking.paymentStatus == PaymentStatusEnum.Un_Paid &&
        newDuration != originalDuration - 1 &&
        newDuration != originalDuration &&
        originalDuration != newDuration - 1
      ) {
        if (!d.courtcharges) {
          toast.error(
            `Court charges are required as the new duration differs from the previous one.`
          );
          return;
        } else if (+d.courtcharges < booking.discountAmount) {
          toast.error(`Discount must be less than Court charges`);
          return;
        } else {
          data.courtcharges = +d.courtcharges;
          data.discount = +d.discount;
        }
      }

      let resp = await Common.ApiService.getInstance().request(
        "BookingRescheduling",
        data,
        "POST"
      );
      if (resp.status == respEnum.Success) {
        setShowReschedule(false);
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getBookingDetails();
        }, 500);
      }
    } catch (error) {
      console.error("Error rescheduling booking:", error);
    } finally {
      setIsRescheduling(false);
    }
  };

  const getBookingDetails = async () => {
    let response = await Common.ApiService.getInstance().request(
      `BookingDetails?id=${bookingId}`
    );

    if (response.status == respEnum.Success && response?.data) {
      let d = response?.data?.[0];

      const groupedResults = Array.isArray(d.result)
        ? d.result.reduce((acc, result) => {
            if (!acc[result.side]) {
              acc[result.side] = [];
            }
            acc[result.side].push(result);
            return acc;
          }, {})
        : {};

      const clubThumbnail =
        d.club?.images?.[0]?.path || "default-thumbnail.jpg";

      let _data = {
        ...d,
        club: {
          ...d.club,
          thumbnail: clubThumbnail,
        },
        groupedResults,
      };
      setBooking(_data);
    }
  };

  const getClubPaymentTypes = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubPaymentTypes"
    );

    if (response?.status == respEnum.Success) {
      const list = response?.data ?? [];
      setPaymentTypeList(list);
      // Build accountId -> paymentTypeId map for quick checks
      const map = {};
      list.forEach((grp) => {
        (grp.options || []).forEach((opt) => {
          map[opt.value] = grp.value; // paymentTypeId
        });
      });
      setAccountTypeById(map);
    }
  };

  const getPOSMachinesDDL = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetPOSMachinesDDL"
    );
    if (response?.status == respEnum.Success) {
      setPosMachines(response?.data || []);
    }
  };

  const getPaymentReceipt = (formikProps) => {
    setRenderImageRecipt(true);
    formikProps.setFieldValue("attachment", booking.paymentReceipt);
  };

  // Prepare booking data for printing
  // const preparePrintData = () => {
  //   return {
  //     // "Club Name": booking?.club?.name || "N/A",
  //     "Reference Number": booking?.refNo || "N/A",
  //     "Booking Mode": booking?.bookingMode
  //       ? Common.Utility.getKeyByValue(BookingModeEnum, booking.bookingMode)
  //       : "N/A",
  //     "Booking Date": booking?.bookingDate
  //       ? Common.moment(booking.bookingDate).format("dddd, DD MMM yyyy")
  //       : "N/A",
  //     Time: booking?.bookingDetail || "N/A",
  //     Sport: booking?.sportName || "N/A",
  //     Court: booking?.courtName || "N/A",
  //     "Player Name": booking?.bookedBy || "N/A",
  //     "Player Cell": booking?.playerCellNo || "N/A",
  //     // "Payment Mode": booking?.paymentTypeId
  //     //   ? Common.Utility.getKeyByValue(PaymentTypeEnum, booking.paymentTypeId)
  //     //   : "N/A",
  //     "Payment Status": booking?.paymentStatus
  //       ? Common.Utility.getKeyByValue(PaymentStatusEnum, booking.paymentStatus)
  //       : "N/A",
  //     "Court Charges": booking?.courtcharges
  //       ? `Rs. ${booking.courtcharges}`
  //       : "N/A",
  //     Discount: booking?.discountAmount
  //       ? `Rs. ${booking.discountAmount}`
  //       : "Rs. 0",
  //     Total: booking?.total ? `Rs. ${booking.total}` : "N/A",
  //     "Received Amount": booking?.receivedAmount
  //       ? `Rs. ${booking.receivedAmount}`
  //       : "Rs. 0",
  //     "Remaining Amount": booking?.remainingAmount
  //       ? `Rs. ${booking.remainingAmount}`
  //       : "Rs. 0",
  //   };
  // };

  const preparePrintData = () => {
    const printData = {
      // "Club Name": booking?.club?.name || "N/A",
      clubPhone: booking?.club?.phone,
      clubLogo: booking?.club?.logo,
      "Reference Number": booking?.refNo || "N/A",
      "Booking Mode": booking?.bookingMode
        ? Common.Utility.getKeyByValue(BookingModeEnum, booking.bookingMode)
        : "N/A",
      "Booking Date": booking?.bookingDate
        ? Common.moment(booking.bookingDate).format("dddd, DD MMM yyyy")
        : "N/A",
      Time: booking?.bookingDetail || "N/A",
      Sport: booking?.sportName || "N/A",
      Court: booking?.courtName || "N/A",
      "Player Name": booking?.bookedBy || "N/A",

      "Player Cell": booking?.playerCellNo || "N/A",
      // "Payment Mode": booking?.paymentTypeId
      //   ? Common.Utility.getKeyByValue(PaymentTypeEnum, booking.paymentTypeId)
      //   : "N/A",
      "Payment Status": booking?.paymentStatus
        ? Common.Utility.getKeyByValue(PaymentStatusEnum, booking.paymentStatus)
        : "N/A",
      "Court Charges": booking?.courtcharges
        ? `Rs. ${booking.courtcharges}`
        : "N/A",
      Discount: booking?.discountAmount
        ? `Rs. ${booking.discountAmount}`
        : "Rs. 0",
      Total: booking?.total ? `Rs. ${booking.total}` : "N/A",
      "Received Amount": booking?.receivedAmount
        ? `Rs. ${booking.receivedAmount}`
        : "Rs. 0",
      "Remaining Amount": booking?.remainingAmount
        ? `Rs. ${booking.remainingAmount}`
        : "Rs. 0",
    };

    // Add Created By only for Club Bookings
    if (booking?.bookingMode == BookingModeEnum.Club_Booking) {
      printData["Created By"] = booking?.createdByName || "N/A";
    }

    return printData;

    // return <PrintReceipt data={printData} />;
  };

const prepareWhatsappData = () => {
    const whatsappData = {
      
      "🆔 Ref": booking?.refNo || "N/A",
      "📅 Date": booking?.bookingDate
        ? Common.moment(booking.bookingDate).format("dddd, DD MMM yyyy")
        : "N/A",
      "⏰ Time": booking?.bookingDetail || "N/A",
      "🎯 Sport": booking?.sportName || "N/A",
      "🏟️ Court": booking?.courtName || "N/A " ,
      
      "💳 Payment": booking?.paymentStatus
        ? Common.Utility.getKeyByValue(PaymentStatusEnum, booking.paymentStatus)
        : "N/A",
      "💰 Total": booking?.total ? `Rs. ${booking.total}` : "N/A",
      "🏷️ Discount": booking?.discountAmount
        ? `Rs. ${booking.discountAmount}`
        : "Rs. 0",
      "📥 Received": booking?.receivedAmount
        ? `Rs. ${booking.receivedAmount}`
        : "Rs. 0",
      "📤 Remaining": booking?.remainingAmount
        ? `Rs. ${booking.remainingAmount}`
        : "Rs. 0",
    };

    return whatsappData;

  };

  const _renderAddPayment = () => (
    <div>
      <Formik
        onSubmit={AddPayment}
        validationSchema={formValidations}
        initialValues={{
          amount: booking?.remainingAmount,
          posmachineid: null,
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => (
          <>
            <div className="mb-3">
              <FormikSearchSectionSelect
                formikProps={formikProps}
                name={"clubAccountId"}
                label={"Payment Account"}
                data={paymentTypeList}
              />
            </div>

            {(() => {
              const selectedAccountId =
                formikProps.values?.clubAccountId?.value;
              const paymentTypeId = accountTypeById[selectedAccountId];
              // PaymentTypeEnum.Online is 2 in backend; we can't import here, so infer by label match as fallback
              const isOnlineType =
                paymentTypeId === 2 ||
                (paymentTypeList || []).some(
                  (grp) =>
                    grp.value === paymentTypeId &&
                    /online/i.test(grp.label || "")
                );
              if (selectedAccountId && isOnlineType) {
                return (
                  <div className="mt-3">
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name={"posmachineid"}
                      label={"POS Machine (optional)"}
                      placeholder={"Select POS Machine"}
                      data={posMachines}
                      labelKey="name"
                      valueKey="id"
                    />
                  </div>
                );
              }
              return null;
            })()}

            <div>
              <FormikInput
                formikProps={formikProps}
                name="amount"
                placeholder="Received Amount"
                label="Received Amount"
                type={"number"}
                min={IntMinLevel}
                onChange={(value) => {
                  if (value < IntMinLevel && value != "") {
                    formikProps.setFieldValue("amount", IntMinLevel);
                  } else {
                    formikProps.setFieldValue("amount", value);
                  }
                }}
              />
            </div>
            {booking?.paymentReceipt && ispPaymentRecBtn && (
              <div className="flex gap-2 mt-2 justify-end">
                <Button
                  color="primary"
                  onClick={() => getPaymentReceipt(formikProps)}
                  className="flex items-center gap-2"
                >
                  <Icon icon="heroicons:arrow-path" width={20} />
                </Button>
              </div>
            )}
            <div className="flex flex-col gap-2 mt-3">
              <FormikSingleFileUpload
                formikProps={formikProps}
                uploadMainTxt="Upload Receipt"
                uploadTxt="Max size 2mb"
                name="attachment"
              />
            </div>
            {/* <div>
              <label style={{ display: 'block', marginBottom: '5px' }}>Remaining Amount:</label>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{booking?.remainingAmount}</div>
            </div> */}

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <Button
                color="success"
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.handleSubmit();
                }}
                className="shadow-md mr-3"
                disabled={isAddingPayment}
              >
                {isAddingPayment ? (
                  <>
                    <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                    Processing...
                  </>
                ) : (
                  <>
                    <Icon
                      icon="heroicons:credit-card"
                      className="w-4 h-4 mr-2"
                    />
                    Add Payment
                  </>
                )}
              </Button>

              <Button
                color="secondary"
                className="secondary"
                onClick={() => setShowAddPayment(false)}
                disabled={isAddingPayment}
              >
                Close
              </Button>

              {/* <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.handleSubmit();
                }}
                className="shadow-md"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Add Payment
              </button> */}
            </div>
          </>
        )}
      </Formik>
    </div>
  );

  const _renderReschedule = () => (
    <div>
      <Formik
        onSubmit={Reschedule}
        validationSchema={formRescheduleValidations}
        enableReinitialize={true}
        initialValues={{
          bookingDate: booking?.startDateTime
            ? Common.moment(booking.startDateTime).format(DateminFormat)
            : Common.moment().format(DateminFormat),
          courtId: booking?.courtId
            ? { value: booking.courtId, label: booking.courtName }
            : null,
          startDateTime: booking?.startDateTime
            ? Common.moment(booking.startDateTime).format("HH:mm")
            : "",
          endDateTime: booking?.endDateTime
            ? Common.moment(booking.endDateTime).format("HH:mm")
            : "",
          courtcharges: booking.courtcharges ? booking.courtcharges : "",
          discount: booking?.discountAmount ? booking.discountAmount : "",
          total: booking?.total ? booking.total : "",
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => {
          const checkDurationChange = (startTime = null, endTime = null) => {
            const currentStartTime =
              startTime || formikProps.values.startDateTime;
            const currentEndTime = endTime || formikProps.values.endDateTime;

            if (!currentStartTime || !currentEndTime) {
              return {
                isDurationChanged: false,
                newDuration: 0,
                originalDuration: 0,
              };
            }

            const bookingDate = dayjs(formikProps.values.bookingDate).format(
              "YYYY-MM-DD"
            );
            const newStartDateTime = dayjs(
              `${bookingDate} ${currentStartTime}`,
              "YYYY-MM-DD HH:mm"
            );
            const newEndDateTime = dayjs(
              `${bookingDate} ${currentEndTime}`,
              "YYYY-MM-DD HH:mm"
            );

            const originalDuration = dayjs(booking?.endDateTime).diff(
              dayjs(booking?.startDateTime),
              "minute"
            );
            const newDuration = newEndDateTime.diff(newStartDateTime, "minute");

            const isDurationChanged =
              newDuration !== originalDuration - 1 &&
              newDuration !== originalDuration &&
              originalDuration !== newDuration - 1;

            return { isDurationChanged, newDuration, originalDuration };
          };

          const { isDurationChanged } = checkDurationChange();
          const isCourtChargesEnabled =
            booking.paymentStatus == PaymentStatusEnum.Un_Paid &&
            isDurationChanged;

          // Filter courts to only show courts from the same sport as the current booking
          const filteredCourtList = courtList.filter(
            (sport) => sport.value === booking?.sportId
          );

          return (
            <>
              <div className="mb-3">
                <FormikSearchSectionSelect
                  formikProps={formikProps}
                  name={"courtId"}
                  label={"Court"}
                  data={filteredCourtList} // Now shows only courts from same sport
                />
              </div>
              <div>
                <FormikDate
                  formikProps={formikProps}
                  name={"bookingDate"}
                  type={"date"}
                  label={"Booking Date"}
                  min={Common.moment().format("YYYY-MM-DD")}
                />
              </div>
              <div className="md:grid md:grid-cols-2 gap-6 items-center mt-4">
                <div className="flex flex-col">
                  <FormikInput
                    formikProps={formikProps}
                    name={"startDateTime"}
                    placeholder={"Start Time"}
                    label={"Start Time"}
                    type={"time"}
                    className="w-full"
                    onBlur={(event) => {
                      const value = event?.target?.value;
                      if (value) {
                        Common.Utility.handleBlur(value, "start Time", true);
                      }
                    }}
                    onChange={(value) => {
                      formikProps.setFieldValue("startDateTime", value);

                      const { isDurationChanged: newDurationChanged } =
                        checkDurationChange(
                          value,
                          formikProps.values.endDateTime
                        );

                      if (booking.paymentStatus == PaymentStatusEnum.Un_Paid) {
                        if (newDurationChanged) {
                          formikProps.setFieldValue("courtcharges", "");
                        } else {
                          formikProps.setFieldValue(
                            "courtcharges",
                            booking?.courtcharges || ""
                          );
                        }
                      }
                    }}
                  />
                </div>
                <div className="flex flex-col">
                  <FormikInput
                    formikProps={formikProps}
                    name={"endDateTime"}
                    placeholder={"End Time"}
                    label={"End Time"}
                    type={"time"}
                    className="w-full"
                    onBlur={(event) => {
                      const value = event?.target?.value;
                      if (value) {
                        Common.Utility.handleBlur(value, "end Time", true);
                      }
                    }}
                    onChange={(value) => {
                      formikProps.setFieldValue("endDateTime", value);

                      const { isDurationChanged: newDurationChanged } =
                        checkDurationChange(
                          formikProps.values.startDateTime,
                          value
                        );

                      if (booking.paymentStatus == PaymentStatusEnum.Un_Paid) {
                        if (newDurationChanged) {
                          formikProps.setFieldValue("courtcharges", "");
                        } else {
                          formikProps.setFieldValue(
                            "courtcharges",
                            booking?.courtcharges || ""
                          );
                        }
                      }
                    }}
                  />
                </div>
              </div>

              {booking.paymentStatus == PaymentStatusEnum.Un_Paid && (
                <>
                  {isDurationChanged && (
                    <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                      <p className="text-sm text-yellow-800 font-medium">
                        Previous Court Charges: Rs. {booking?.courtcharges || 0}
                      </p>
                      <p className="text-xs text-yellow-600 mt-1">
                        Duration has changed. Please enter new court charges.
                      </p>
                    </div>
                  )}

                  <div className="md:grid md:grid-cols-3 gap-6 items-center mt-4">
                    <div className="flex flex-col">
                      <FormikInput
                        formikProps={formikProps}
                        name={"courtcharges"}
                        placeholder={
                          isDurationChanged
                            ? "Enter new court charges"
                            : "Court Charges"
                        }
                        label={
                          isDurationChanged
                            ? "New Court Charges *"
                            : "Court Charges"
                        }
                        type={"number"}
                        max={IntMax}
                        disabled={!isCourtChargesEnabled}
                        min={1}
                        onChange={(value) => {
                          if (isCourtChargesEnabled) {
                            if (value < 1 && value !== "") {
                              formikProps.setFieldValue("courtcharges", 1);
                            } else if (value > IntMax) {
                              toast.error(
                                `Court charges cannot be greater than ${IntMax}`
                              );
                              formikProps.setFieldValue("courtcharges", "");
                            } else {
                              formikProps.setFieldValue("courtcharges", value);
                              const discountValue =
                                formikProps.values.discount || 0;
                              const total = (value || 0) - discountValue;
                              formikProps.setFieldValue("total", total);
                            }
                          }
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <FormikInput
                        formikProps={formikProps}
                        name={"discount"}
                        placeholder={"Discount"}
                        label={"Discount"}
                        type={"number"}
                        max={formikProps.values.courtcharges}
                        min={IntMinLevel}
                        disabled={true}
                      />
                    </div>
                    <div className="flex flex-col">
                      <FormikInput
                        formikProps={formikProps}
                        name={"total"}
                        placeholder={"Total"}
                        label={"Total"}
                        type={"number"}
                        disabled={true}
                        value={
                          (formikProps.values.courtcharges || 0) -
                          (formikProps.values.discount || 0)
                        }
                      />
                    </div>
                  </div>
                </>
              )}

              <div style={{ marginTop: "20px", textAlign: "right" }}>
                <Button
                  color="success"
                  onClick={(e) => {
                    e.preventDefault();
                    formikProps.handleSubmit();
                  }}
                  className="shadow-md mr-3"
                  disabled={isRescheduling}
                >
                  {isRescheduling ? (
                    <>
                      <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                      Rescheduling...
                    </>
                  ) : (
                    <>
                      <Icon
                        icon="heroicons:calendar-days"
                        className="w-4 h-4 mr-2"
                      />
                      Reschedule
                    </>
                  )}
                </Button>

                <Button
                  color="secondary"
                  className="secondary"
                  onClick={() => setShowReschedule(false)}
                  disabled={isRescheduling}
                >
                  Close
                </Button>
              </div>
            </>
          );
        }}
      </Formik>
    </div>
  );

  const _renderAddDiscount = () => (
    <div>
      <Formik
        onSubmit={AddDiscount}
        validationSchema={dynamicDiscountValidation}
        enableReinitialize
        initialValues={{
          discountTab: "bank", // Default to Club Discount
          discountType: "fixed", // Default to fixed amount
          percentage: "",
          discount: "",
          clubbankdiscountid: "",
          posmachineid: null,
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => {
          // Calculate discount amount when percentage changes
          const calculateDiscountFromPercentage = (percentage) => {
            if (percentage && booking?.courtcharges) {
              const discountAmount = Math.round(
                (booking.courtcharges * percentage) / 100
              );
              return discountAmount;
            }
            return "";
          };

          return (
            <>
              {/* Tabs for Club Discount and Card Discount */}
              <div className="mt-4">
                <Tabs
                  defaultValue="bank"
                  value={formikProps.values.discountTab || "bank"}
                  onValueChange={(value) => {
                    formikProps.setFieldValue("discountTab", value);
                    // Reset discount fields when switching tabs
                    formikProps.setFieldValue("discountType", "fixed");
                    formikProps.setFieldValue("discount", "");
                    formikProps.setFieldValue("percentage", "");
                    formikProps.setFieldValue("clubbankdiscountid", "");
                  }}
                  className="mb-2"
                >
                  <TabsList className="grid w-full grid-cols-2 bg-gray-100 p-1 rounded-lg">
                    <TabsTrigger
                      value="bank"
                      className="data-[state=active]:bg-white data-[state=active]:text-blue-600 data-[state=active]:shadow-sm transition-all duration-200"
                    >
                      <Icon icon="mdi:discount" className="w-4 h-4 mr-2" />
                      Club Discount
                    </TabsTrigger>
                    <TabsTrigger
                      value="card"
                      className="data-[state=active]:bg-white data-[state=active]:text-blue-600 data-[state=active]:shadow-sm transition-all duration-200"
                    >
                      <Icon
                        icon="heroicons:credit-card"
                        className="w-4 h-4 mr-2"
                      />
                      Card Discount
                    </TabsTrigger>
                  </TabsList>

                  {/* Club Discount Tab */}
                  <TabsContent value="bank">
                    <div className="space-y-4">
                      <div className="space-y-3">
                        <label className="text-sm font-medium text-gray-700 mb-3 block">
                          Discount Type
                        </label>
                        <div className="grid grid-cols-2 gap-3">
                          <button
                            type="button"
                            onClick={() => {
                              formikProps.setFieldValue(
                                "discountType",
                                "fixed"
                              );
                              formikProps.setFieldValue("discount", "");
                              formikProps.setFieldValue("percentage", "");
                            }}
                            className={`p-2 rounded-lg border-2 transition-all duration-200 ${
                              formikProps.values.discountType === "fixed"
                                ? "border-blue-500 bg-blue-50 text-blue-700 shadow-md"
                                : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50"
                            }`}
                          >
                            <div className="flex items-center justify-center gap-2">
                              <div
                                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                                  formikProps.values.discountType === "fixed"
                                    ? "border-blue-500 bg-blue-500"
                                    : "border-gray-300"
                                }`}
                              >
                                {formikProps.values.discountType ===
                                  "fixed" && (
                                  <div className="w-2 h-2 bg-white rounded-full"></div>
                                )}
                              </div>
                              <span className="font-medium">Fixed</span>
                            </div>
                          </button>

                          <button
                            type="button"
                            onClick={() => {
                              formikProps.setFieldValue(
                                "discountType",
                                "percentage"
                              );
                              formikProps.setFieldValue("discount", "");
                              formikProps.setFieldValue("percentage", "");
                            }}
                            className={`p-2 rounded-lg border-2 transition-all duration-200 ${
                              formikProps.values.discountType === "percentage"
                                ? "border-blue-500 bg-blue-50 text-blue-700 shadow-md"
                                : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50"
                            }`}
                          >
                            <div className="flex items-center justify-center gap-2">
                              <div
                                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                                  formikProps.values.discountType ===
                                  "percentage"
                                    ? "border-blue-500 bg-blue-500"
                                    : "border-gray-300"
                                }`}
                              >
                                {formikProps.values.discountType ===
                                  "percentage" && (
                                  <div className="w-2 h-2 bg-white rounded-full"></div>
                                )}
                              </div>
                              <Icon
                                icon="heroicons:percent"
                                className="w-5 h-5"
                              />
                              <span className="font-medium">Percentage</span>
                            </div>
                          </button>
                        </div>
                      </div>

                      <div className="mt-4">
                        <div className="p-3 bg-blue-50 border border-blue-200 rounded-md mb-3">
                          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
                            <p className="text-sm text-blue-800 font-medium">
                              Court Charges: Rs. {booking?.courtcharges || 0}
                            </p>
                            <p className="text-sm text-blue-800 font-medium">
                              Remaining Amount: Rs.{" "}
                              {booking?.remainingAmount || 0}
                            </p>
                          </div>
                        </div>

                        {/* Club Discount - Fixed Amount */}
                        {formikProps.values.discountType === "fixed" && (
                          <div className="md:grid md:grid-cols-2 gap-4">
                            <FormikInput
                              formikProps={formikProps}
                              name={"discount"}
                              placeholder={"Enter Amount"}
                              label={"Discount Amount"}
                              type={"number"}
                              max={IntMax}
                              min={IntMinLevel}
                              onChange={(value) => {
                                if (value < IntMinLevel && value !== "") {
                                  formikProps.setFieldValue(
                                    "discount",
                                    IntMinLevel
                                  );
                                } else {
                                  formikProps.setFieldValue("discount", value);
                                }
                              }}
                            />
                            <FormikSearchSelect
                              formikProps={formikProps}
                              name={"posmachineid"}
                              label={"POS Machine (optional)"}
                              placeholder={"Select POS Machine"}
                              data={posMachines}
                              labelKey="name"
                              valueKey="id"
                            />
                          </div>
                        )}

                        {/* Club Discount - Percentage */}
                        {formikProps.values.discountType === "percentage" && (
                          <div className="space-y-4">
                            <div className="flex flex-row gap-4">
                              <div className="flex-1">
                                <FormikInput
                                  formikProps={formikProps}
                                  name={"percentage"}
                                  placeholder={"Enter Percentage"}
                                  label={"Discount Percentage"}
                                  type={"number"}
                                  max={100}
                                  min={1}
                                  onChange={(value) => {
                                    if (value > 100) {
                                      toast.error(
                                        "Percentage cannot be greater than 100%"
                                      );
                                      formikProps.setFieldValue(
                                        "percentage",
                                        100
                                      );
                                      value = 100;
                                    } else if (value < 0) {
                                      formikProps.setFieldValue(
                                        "percentage",
                                        ""
                                      );
                                      return;
                                    }

                                    formikProps.setFieldValue(
                                      "percentage",
                                      value
                                    );

                                    // Calculate and set discount amount
                                    const discountAmount =
                                      calculateDiscountFromPercentage(value);
                                    formikProps.setFieldValue(
                                      "discount",
                                      discountAmount
                                    );
                                  }}
                                />
                              </div>
                              <div className="flex-1">
                                <FormikInput
                                  formikProps={formikProps}
                                  name={"discount"}
                                  placeholder={
                                    "Auto-calculated from percentage"
                                  }
                                  label={"Discount Amount"}
                                  type={"number"}
                                  disabled={true}
                                />
                              </div>
                            </div>
                            <FormikSearchSelect
                              formikProps={formikProps}
                              name={"posmachineid"}
                              label={"POS Machine (optional)"}
                              placeholder={"Select POS Machine"}
                              data={posMachines}
                              labelKey="name"
                              valueKey="id"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </TabsContent>

                  {/* Card Discount Tab */}
                  <TabsContent value="card">
                    <div className="space-y-4">
                      {/* Check if no bank discounts are available */}
                      {clubDiscountList.length === 0 ? (
                        <div className="text-center py-8">
                          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                            <div className="flex flex-col items-center gap-3">
                              <div className="bg-yellow-100 p-3 rounded-full">
                                <Icon
                                  icon="heroicons:exclamation-triangle"
                                  className="w-8 h-8 text-yellow-600"
                                />
                              </div>
                              <div>
                                <h3 className="text-lg font-medium text-yellow-800 mb-2">
                                  No Bank Discount Cards Available
                                </h3>
                                <p className="text-sm text-yellow-700">
                                  You haven't added any bank discount cards yet.
                                  Please add bank discount cards to use this
                                  feature.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          {/* Bank Selection - Required for Card Discount */}
                          <div className="mb-4">
                            <FormikSearchSelect
                              formikProps={formikProps}
                              name={"clubbankdiscountid"}
                              placeholder="Select a bank..."
                              label="Bank Discount *"
                              data={clubDiscountList}
                              onChange={(selectedCard) => {
                                debugger;
                                formikProps.setFieldValue(
                                  "clubbankdiscountid",
                                  selectedCard || ""
                                );

                                if (selectedCard && selectedCard) {
                                  // Find the selected card object from the dropdown data
                                  const selectedCardObj = clubDiscountList.find(
                                    (card) => card.id === selectedCard
                                  );

                                  if (selectedCardObj) {
                                    // Check discount type and set form values automatically
                                    if (
                                      selectedCardObj.discountType ===
                                      ClubBankDiscountTypeEnum.Percentage
                                    ) {
                                      // Set percentage-based discount
                                      formikProps.setFieldValue(
                                        "discountType",
                                        "percentage"
                                      );
                                      formikProps.setFieldValue(
                                        "percentage",
                                        selectedCardObj.discountValue || ""
                                      );

                                      // Calculate discount amount from percentage
                                      if (
                                        selectedCardObj.discountValue &&
                                        booking?.courtcharges
                                      ) {
                                        const originalDiscount = Math.round(
                                          (booking.courtcharges *
                                            selectedCardObj.discountValue) /
                                            100
                                        );

                                        // Set original discount
                                        formikProps.setFieldValue(
                                          "originalDiscount",
                                          originalDiscount
                                        );

                                        // Apply cap amount concept
                                        let finalDiscount = originalDiscount;
                                        if (selectedCardObj.maxDiscount) {
                                          finalDiscount = Math.min(
                                            originalDiscount,
                                            selectedCardObj.maxDiscount
                                          );
                                        }

                                        // Set final discount (capped if applicable)
                                        formikProps.setFieldValue(
                                          "finalDiscount",
                                          finalDiscount
                                        );

                                        // Always set the main discount field to finalDiscount for form submission
                                        formikProps.setFieldValue(
                                          "discount",
                                          finalDiscount
                                        );
                                      } else {
                                        formikProps.setFieldValue(
                                          "originalDiscount",
                                          ""
                                        );
                                        formikProps.setFieldValue(
                                          "finalDiscount",
                                          ""
                                        );
                                        formikProps.setFieldValue(
                                          "discount",
                                          ""
                                        );
                                      }
                                    } else if (
                                      selectedCardObj.discountType ===
                                      ClubBankDiscountTypeEnum.Fixed_Amount
                                    ) {
                                      // Set fixed amount discount
                                      formikProps.setFieldValue(
                                        "discountType",
                                        "fixed"
                                      );

                                      const fixedDiscount =
                                        selectedCardObj.discountValue || "";

                                      // For fixed amount, original and final are the same
                                      formikProps.setFieldValue(
                                        "originalDiscount",
                                        fixedDiscount
                                      );
                                      formikProps.setFieldValue(
                                        "finalDiscount",
                                        fixedDiscount
                                      );
                                      formikProps.setFieldValue(
                                        "discount",
                                        fixedDiscount
                                      );
                                      formikProps.setFieldValue(
                                        "percentage",
                                        ""
                                      );
                                    }
                                  }
                                } else {
                                  // Clear fields when no card is selected
                                  formikProps.setFieldValue(
                                    "discountType",
                                    "fixed"
                                  );
                                  formikProps.setFieldValue("discount", "");
                                  formikProps.setFieldValue(
                                    "originalDiscount",
                                    ""
                                  );
                                  formikProps.setFieldValue(
                                    "finalDiscount",
                                    ""
                                  );
                                  formikProps.setFieldValue("percentage", "");
                                }
                              }}
                            />
                          </div>

                          <div className="space-y-3">
                            <label className="text-sm font-medium text-gray-700 mb-3 block">
                              Discount Type
                            </label>
                            <div className="grid grid-cols-2 gap-3">
                              <button
                                type="button"
                                onClick={() => {
                                  formikProps.setFieldValue(
                                    "discountType",
                                    "fixed"
                                  );
                                  formikProps.setFieldValue("discount", "");
                                  formikProps.setFieldValue("percentage", "");
                                }}
                                className={`p-2 rounded-lg border-2 transition-all duration-200 ${
                                  formikProps.values.discountType === "fixed"
                                    ? "border-blue-500 bg-blue-50 text-blue-700 shadow-md"
                                    : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50"
                                }`}
                              >
                                <div className="flex items-center justify-center gap-2">
                                  <div
                                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                                      formikProps.values.discountType ===
                                      "fixed"
                                        ? "border-blue-500 bg-blue-500"
                                        : "border-gray-300"
                                    }`}
                                  >
                                    {formikProps.values.discountType ===
                                      "fixed" && (
                                      <div className="w-2 h-2 bg-white rounded-full"></div>
                                    )}
                                  </div>
                                  <span className="font-medium">Fixed</span>
                                </div>
                              </button>

                              <button
                                type="button"
                                onClick={() => {
                                  formikProps.setFieldValue(
                                    "discountType",
                                    "percentage"
                                  );
                                  formikProps.setFieldValue("discount", "");
                                  formikProps.setFieldValue("percentage", "");
                                }}
                                className={`p-2 rounded-lg border-2 transition-all duration-200 ${
                                  formikProps.values.discountType ===
                                  "percentage"
                                    ? "border-blue-500 bg-blue-50 text-blue-700 shadow-md"
                                    : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50"
                                }`}
                              >
                                <div className="flex items-center justify-center gap-2">
                                  <div
                                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                                      formikProps.values.discountType ===
                                      "percentage"
                                        ? "border-blue-500 bg-blue-500"
                                        : "border-gray-300"
                                    }`}
                                  >
                                    {formikProps.values.discountType ===
                                      "percentage" && (
                                      <div className="w-2 h-2 bg-white rounded-full"></div>
                                    )}
                                  </div>
                                  <Icon
                                    icon="heroicons:percent"
                                    className="w-5 h-5"
                                  />
                                  <span className="font-medium">
                                    Percentage
                                  </span>
                                </div>
                              </button>
                            </div>
                          </div>

                          <div className="mt-4">
                            <div className="p-3 bg-blue-50 border border-blue-200 rounded-md mb-3">
                              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
                                <p className="text-sm text-blue-800 font-medium">
                                  Court Charges: Rs.{" "}
                                  {booking?.courtcharges || 0}
                                </p>
                                <p className="text-sm text-blue-800 font-medium">
                                  Remaining Amount: Rs.{" "}
                                  {booking?.remainingAmount || 0}
                                </p>
                              </div>
                            </div>

                            {/* Card Discount - Fixed Amount */}
                            {formikProps.values.discountType === "fixed" && (
                              <>
                                <div className="md:grid md:grid-cols-2 gap-4">
                                  <FormikInput
                                    formikProps={formikProps}
                                    name={"discount"}
                                    placeholder={"Enter Amount"}
                                    label={"Discount Amount"}
                                    type={"number"}
                                    max={IntMax}
                                    min={IntMinLevel}
                                    onChange={(value) => {
                                      if (value < IntMinLevel && value !== "") {
                                        formikProps.setFieldValue(
                                          "discount",
                                          IntMinLevel
                                        );
                                      } else {
                                        formikProps.setFieldValue(
                                          "discount",
                                          value
                                        );
                                      }
                                    }}
                                  />
                                  <FormikSearchSelect
                                    formikProps={formikProps}
                                    name={"posmachineid"}
                                    label={"POS Machine (optional)"}
                                    placeholder={"Select POS Machine"}
                                    data={posMachines}
                                    labelKey="name"
                                    valueKey="id"
                                  />
                                </div>
                                {/* Show max discount note for selected card */}
                                {formikProps.values.clubbankdiscountid &&
                                  (() => {
                                    const selectedCardObj =
                                      clubDiscountList.find(
                                        (card) =>
                                          card.id ===
                                          formikProps.values.clubbankdiscountid
                                      );
                                    return selectedCardObj?.maxDiscount ? (
                                      <div className="mt-2">
                                        <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2 flex items-center gap-2">
                                          <Icon
                                            icon="heroicons:information-circle"
                                            className="w-4 h-4 text-red-500"
                                          />
                                          Maximum discount for this bank is Rs.{" "}
                                          {selectedCardObj.maxDiscount}
                                        </p>
                                      </div>
                                    ) : null;
                                  })()}
                              </>
                            )}

                            {/* Card Discount - Percentage */}
                            {formikProps.values.discountType ===
                              "percentage" && (
                              <>
                                <div className="space-y-4">
                                  <div className="flex flex-row gap-4">
                                    <div className="flex-1">
                                      <FormikInput
                                        formikProps={formikProps}
                                        name={"percentage"}
                                        placeholder={"Enter Percentage"}
                                        label={"Discount %"}
                                        type={"number"}
                                        max={100}
                                        min={1}
                                        onChange={(value) => {
                                          if (value > 100) {
                                            toast.error(
                                              "Percentage cannot be greater than 100%"
                                            );
                                            formikProps.setFieldValue(
                                              "percentage",
                                              100
                                            );
                                            value = 100;
                                          } else if (value < 0) {
                                            formikProps.setFieldValue(
                                              "percentage",
                                              ""
                                            );
                                            return;
                                          }

                                          formikProps.setFieldValue(
                                            "percentage",
                                            value
                                          );

                                          // Calculate original discount amount from percentage
                                          const originalDiscount =
                                            calculateDiscountFromPercentage(
                                              value
                                            );

                                          // Set original discount
                                          formikProps.setFieldValue(
                                            "originalDiscount",
                                            originalDiscount
                                          );

                                          // Apply cap amount concept - get max discount from selected card
                                          let finalDiscount = originalDiscount;
                                          if (
                                            formikProps.values
                                              .clubbankdiscountid
                                          ) {
                                            const selectedCardObj =
                                              clubDiscountList.find(
                                                (card) =>
                                                  card.id ===
                                                  formikProps.values
                                                    .clubbankdiscountid
                                              );

                                            // Apply cap: use the lower of original discount or max discount
                                            if (selectedCardObj?.maxDiscount) {
                                              finalDiscount = Math.min(
                                                originalDiscount,
                                                selectedCardObj.maxDiscount
                                              );
                                            }
                                          }

                                          // Set final discount (capped if applicable)
                                          formikProps.setFieldValue(
                                            "finalDiscount",
                                            finalDiscount
                                          );

                                          // Always set the main discount field to finalDiscount for form submission
                                          formikProps.setFieldValue(
                                            "discount",
                                            finalDiscount
                                          );
                                        }}
                                      />
                                    </div>

                                    <div className="flex-1">
                                      <FormikInput
                                        formikProps={formikProps}
                                        name={"originalDiscount"}
                                        placeholder={
                                          "Auto-calculated from percentage"
                                        }
                                        label={"Discount Amount"}
                                        type={"number"}
                                        disabled={true}
                                      />
                                    </div>

                                    {/* Show total amount only when original discount exceeds max discount */}
                                    {formikProps.values.originalDiscount &&
                                      formikProps.values.finalDiscount &&
                                      formikProps.values.clubbankdiscountid &&
                                      (() => {
                                        const selectedCardObj =
                                          clubDiscountList.find(
                                            (card) =>
                                              card.id ===
                                              formikProps.values
                                                .clubbankdiscountid
                                          );
                                        return (
                                          selectedCardObj?.maxDiscount &&
                                          formikProps.values.originalDiscount >
                                            selectedCardObj.maxDiscount
                                        );
                                      })() && (
                                        <div className="flex-1">
                                          <FormikInput
                                            formikProps={formikProps}
                                            name={"finalDiscount"}
                                            placeholder={
                                              "Auto-calculated from percentage"
                                            }
                                            label={"Final Discount"}
                                            type={"number"}
                                            disabled={true}
                                          />
                                        </div>
                                      )}
                                  </div>
                                  <FormikSearchSelect
                                    formikProps={formikProps}
                                    name={"posmachineid"}
                                    label={"POS Machine (optional)"}
                                    placeholder={"Select POS Machine"}
                                    data={posMachines}
                                    labelKey="name"
                                    valueKey="id"
                                  />
                                </div>
                                {/* Show max discount note for selected card */}
                                {formikProps.values.clubbankdiscountid &&
                                  (() => {
                                    const selectedCardObj =
                                      clubDiscountList.find(
                                        (card) =>
                                          card.id ===
                                          formikProps.values.clubbankdiscountid
                                      );
                                    return selectedCardObj?.maxDiscount ? (
                                      <div className="mt-2">
                                        <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2 flex items-center gap-2">
                                          <Icon
                                            icon="heroicons:information-circle"
                                            className="w-4 h-4 text-red-500"
                                          />
                                          Maximum discount for this bank is Rs.{" "}
                                          {selectedCardObj.maxDiscount}
                                        </p>
                                      </div>
                                    ) : null;
                                  })()}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </TabsContent>
                </Tabs>
              </div>

              {/* File upload section - Only show if bank discounts are available or on club discount tab */}
              {(formikProps.values.discountTab === "bank" ||
                clubDiscountList.length > 0) && (
                <div className="flex flex-col gap-2 mt-3">
                  <FormikSingleFileUpload
                    formikProps={formikProps}
                    uploadMainTxt="Upload Receipt (Optional)"
                    uploadTxt="Max size 2mb"
                    name="attachment"
                    height={100}
                  />
                </div>
              )}

              {/* Action buttons - Only show if form is valid */}
              {(formikProps.values.discountTab === "bank" ||
                clubDiscountList.length > 0) && (
                <div style={{ marginTop: "20px", textAlign: "right" }}>
                  <Button
                    color="success"
                    onClick={(e) => {
                      e.preventDefault();
                      formikProps.handleSubmit();
                    }}
                    className="shadow-md mr-3"
                    disabled={isAddingDiscount}
                  >
                    {isAddingDiscount ? (
                      <>
                        <Icon
                          icon="eos-icons:loading"
                          className="w-4 h-4 mr-2"
                        />
                        Processing...
                      </>
                    ) : (
                      <>
                        <Icon
                          icon="heroicons:ticket"
                          className="w-4 h-4 mr-2"
                        />
                        Add Discount
                      </>
                    )}
                  </Button>

                  <Button
                    color="secondary"
                    className="secondary"
                    onClick={() => setShowAddDiscount(false)}
                    disabled={isAddingDiscount}
                  >
                    Close
                  </Button>
                </div>
              )}
            </>
          );
        }}
      </Formik>
    </div>
  );

  const _renderCancelBooking = () => (
    <div>
      <Formik
        onSubmit={cancelledBooking}
        validationSchema={formCancelValidations}
        enableReinitialize={false}
        initialValues={{
          cancellationreasonid: null,
          reason: "",
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => {
          // Calculate if current selection is "Other" reason directly from formik values
          const currentReasonId = formikProps.values.cancellationreasonid;
          const currentReasonData = cancellationReasons.find(
            (r) => r.value === currentReasonId
          );
          const isOtherReason = currentReasonData?.isOther || false;

          const handleReasonChange = (reasonId) => {
            // force set the selected reason ID immediately
            formikProps.setFieldValue("cancellationreasonid", reasonId);

            // Find the selected reason data
            const selectedReasonData = cancellationReasons.find(
              (r) => r.value === reasonId
            );

            // If it's an "Other" reason, clear the reason textbox for user input
            if (selectedReasonData?.isOther) {
              formikProps.setFieldValue("reason", "");
            } else {
              // For non-"Other" reasons, set the reason label
              formikProps.setFieldValue(
                "reason",
                selectedReasonData?.label || ""
              );
            }
          };

          return (
            <>
              <div className="mb-4">
                <FormikSearchSelect
                  formikProps={formikProps}
                  name="cancellationreasonid"
                  label={`Reason ${
                    booking?.bookingMode === BookingModeEnum.App_Booking
                      ? "*"
                      : "(Optional)"
                  }`}
                  placeholder="Select a reason..."
                  data={cancellationReasons}
                  labelKey="label"
                  valueKey="value"
                  onChange={handleReasonChange}
                />
              </div>

              {isOtherReason && (
                <div className="mb-4">
                  <FormikTextArea
                    formikProps={formikProps}
                    name="reason"
                    placeholder="Please specify the reason..."
                    type="textarea"
                    label="Specify Reason *"
                    maxLength={50}
                  />
                </div>
              )}

              <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-200">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowCancelBooking(false);
                    setSelectedReason(null);
                    setShowOtherReason(false);
                  }}
                  className="px-6 py-2 hover:bg-gray-50 transition-colors"
                  disabled={isCancelling}
                >
                  <Icon icon="heroicons:x-mark" className="w-4 h-4 mr-2" />
                  Close
                </Button>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    formikProps.handleSubmit();
                  }}
                  disabled={isCancelling}
                  className="px-6 py-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg hover:shadow-xl transition-all duration-200"
                >
                  {isCancelling ? (
                    <>
                      <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                      Cancelling...
                    </>
                  ) : (
                    <>
                      <Icon
                        icon="heroicons:x-circle"
                        className="w-4 h-4 mr-2"
                      />
                      Cancel Booking
                    </>
                  )}
                </Button>
              </div>
            </>
          );
        }}
      </Formik>
    </div>
  );

 const _renderAddTax = () => (
  <div>
    <Formik
      onSubmit={applyTax}
      enableReinitialize
      initialValues={{
        tax_id: null,
        taxType: "",
        tax_percentage: "",
        tax_amount: "",
      }}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <>
          {/* 🔹 Tax Selection */}
          <div className="mb-3">
            <FormikSearchSelect
              formikProps={formikProps}
              name={"tax_id"}
              label={"Tax *"}
              placeholder={"Select Tax"}
              data={taxList
                ?.filter((x) => x.isactive)
                ?.map((tax) => ({
                  id: tax.id,
                  name: tax.name,
                }))}
              onChange={(value) => {
                const selectedTax = taxList.find((t) => t.id === value);

                if (selectedTax) {
                  const baseAmount = booking?.courtcharges || 0;

                  const taxAmount =
                    selectedTax.type === TaxTypeEnum.Inclusive
                      ? calculateInclusiveTaxAmount(
                          baseAmount,
                          selectedTax.percentage
                        )
                      : Math.round(
                          (baseAmount * selectedTax.percentage) / 100
                        );

                  formikProps.setFieldValue("tax_id", value);
                  formikProps.setFieldValue("taxType", selectedTax.type);
                  formikProps.setFieldValue(
                    "tax_percentage",
                    selectedTax.percentage
                  );
                  formikProps.setFieldValue("tax_amount", taxAmount);
                } else {
                  formikProps.resetForm();
                }
              }}
            />
          </div>

          {/* 🔹 Tax Type */}
          <div className="mb-3">
            <FormikInput
              formikProps={formikProps}
              name="taxType"
              label="Tax Type"
              disabled
              value={
                formikProps.values.taxType === TaxTypeEnum.Inclusive
                  ? "Inclusive"
                  : formikProps.values.taxType === TaxTypeEnum.Exclusive
                  ? "Exclusive"
                  : ""
              }
            />
          </div>

          {/* 🔹 Tax Percentage */}
          <div className="mb-3">
            <FormikInput
              formikProps={formikProps}
              name="tax_percentage"
              label="Tax %"
              disabled
            />
          </div>

          {/* 🔹 Tax Amount */}
          <div className="mb-3">
            <FormikInput
              formikProps={formikProps}
              name="tax_amount"
              label="Tax Amount"
              disabled
            />
          </div>

          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Button
              color="success"
              onClick={(e) => {
                e.preventDefault();
                if (!formikProps.values.tax_id) {
                  Common.showToast("Please select tax", "Error", "info");
                  return;
                }
                formikProps.handleSubmit();
              }}
              className="shadow-md mr-3"
              disabled={isAddingTax}
            >
              {isAddingTax ? (
                <>
                  <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                  Processing...
                </>
              ) : (
                <>
                  <Icon
                    icon="heroicons:calculator"
                    className="w-4 h-4 mr-2"
                  />
                  Apply Tax
                </>
              )}
            </Button>

            <Button
              color="secondary"
              onClick={() => setShowAddTax(false)}
              disabled={isAddingTax}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </Formik>
  </div>
);


  const _renderNotes = () => (
    <div>
      <Formik
        onSubmit={AddNotes}
        validationSchema={formNotesValidations}
        enableReinitialize
        initialValues={{
          notes: booking?.notes ? booking.notes : "",
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => (
          <>
            <div>
              <FormikTextArea
                formikProps={formikProps}
                name={"notes"}
                placeholder={"Enter Note..."}
                type={"textarea"}
                label={"Note"}
                maxLength={150}
                min={2}
              />
            </div>

            <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-200">
              <Button
                variant="outline"
                onClick={() => setShowNotes(false)}
                className="px-6 py-2 hover:bg-gray-50 transition-colors"
                disabled={isAddingNotes}
              >
                <Icon icon="heroicons:x-mark" className="w-4 h-4 mr-2" />
                Close
              </Button>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.handleSubmit();
                }}
                className="px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white shadow-lg hover:shadow-xl transition-all duration-200"
                disabled={isAddingNotes}
              >
                {isAddingNotes ? (
                  <>
                    <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                    Saving...
                  </>
                ) : (
                  <>
                    <Icon icon="heroicons:plus" className="w-4 h-4 mr-2" />
                    Add Notes
                  </>
                )}
              </Button>
            </div>
          </>
        )}
      </Formik>
    </div>
  );
  return (
    <>
      {/* Modern Header */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 mb-6 shadow-sm border border-blue-100">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-full">
              <Icon
                icon="heroicons:document-text"
                className="w-6 h-6 text-blue-600"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Booking #{booking?.refNo}
              </h1>
              <p className="text-gray-600 mt-1">
                {booking?.club?.name} •{" "}
                {booking?.bookingDate &&
                  dayjs(booking.bookingDate).format("MMM DD, YYYY")}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <PrintReceipt
              data={preparePrintData()}
              title={booking?.club?.name}
              subtitle="Booking Receipt"
              showPrintButton={true}
              showViewButton={true}
              buttonText="Print Receipt"
              buttonIcon="heroicons:printer"
              buttonSize="sm"
              buttonVariant="outline"
              className="bg-white hover:bg-gray-50"
            />

           <SendWhatsapp
              phone={booking?.playerCellNo}
              header={`👋 Assalam-o-Alaikum ${booking?.bookedBy}\nYour booking details are as follows:`}
              data={prepareWhatsappData()}
              footer="⚡ Powered By PlayPro!"
              buttonText="Send Whatsapp"
              buttonIcon = "mdi:whatsapp"
              buttonSize="sm"
              buttonVariant="outline"
              className="flex items-center gap-1 border border-green-500 bg-white text-green-500 hover:bg-green-500 hover:text-white hover:border-white transition-colors duration-200"
            />



            <Breadcrumbs className="hidden sm:flex">
              <BreadcrumbItem
                onClick={() =>
                  navigate(
                    global?.roleId == RoleEnum.Super_Admin
                      ? "/Booking"
                      : "/app/clubbookings"
                  )
                }
                className="text-gray-600 hover:text-blue-600 transition-colors"
              >
                Bookings
              </BreadcrumbItem>
              <BreadcrumbItem className="text-gray-900 font-medium">
                Detail
              </BreadcrumbItem>
            </Breadcrumbs>
          </div>
        </div>
      </div>

      {/* Modern Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Sidebar */}
        <div className="lg:col-span-5">
          <Card className="h-fit shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardHeader className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-t-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-white/20 p-2 rounded-lg">
                    <Icon
                      icon="heroicons:building-storefront"
                      className="w-5 h-5"
                    />
                  </div>
                  <div>
                    <h2 className="font-bold text-lg">{booking?.club?.name}</h2>
                    <p className="text-blue-100 text-sm">Club Details</p>
                  </div>
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-6">
              <BookingDetailSidebar
                setShowAddPayment={setShowAddPayment}
                setShowReschedule={setShowReschedule}
                setShowAddDiscount={setShowAddDiscount}
                setShowCancelBooking={setShowCancelBooking}
                setShowNotes={setShowNotes}
                setShowAddTax={setShowAddTax}
                booking={booking}
                setBooking={setBooking}
                getBookingDetails={getBookingDetails}
                isAddingPayment={isAddingPayment}
                isAddingDiscount={isAddingDiscount}
                isRescheduling={isRescheduling}
                isCancelling={isCancelling}
                isAddingNotes={isAddingNotes}
                isAddingTax={isAddingTax}
                onAdddNote={(param) => {
                  alert(param);
                }}
              />
            </CardContent>
          </Card>
        </div>

        {/* Main Content */}
        <div className="lg:col-span-7">
          <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardHeader className="bg-gradient-to-r from-gray-50 to-gray-100 border-b">
              <div className="flex items-center gap-3">
                <div className="bg-gray-200 p-2 rounded-lg">
                  <Icon
                    icon="heroicons:clipboard-document-list"
                    className="w-5 h-5 text-gray-600"
                  />
                </div>
                <div>
                  <h2 className="font-bold text-lg text-gray-900">
                    Booking Details
                  </h2>
                  <p className="text-gray-600 text-sm">
                    Complete booking information
                  </p>
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-6">
              <BooingFurthurDetails
                booking={booking}
                openSheet={handleEditSheetOpen}
                handleSidebar={() => setShowSidebar(true)}
                setShowNotes={setShowNotes}
                onReceiptUpdated={getBookingDetails}
              />
            </CardContent>
          </Card>
        </div>
      </div>
      {/* Modern Modal Dialogs */}
      <DialogModal
        title={
          <div className="flex items-center gap-3">
            <div className="bg-green-100 p-2 rounded-lg">
              <Icon
                icon="heroicons:credit-card"
                className="w-5 h-5 text-green-600"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Add Payment</h3>
              <p className="text-gray-600 text-sm">
                Process a new payment for this booking
              </p>
            </div>
          </div>
        }
        open={showAddPayment}
        setOpen={setShowAddPayment}
        Child={_renderAddPayment}
        className="max-w-2xl max-h-[90vh] overflow-hidden flex flex-col"
        contentClassName="overflow-y-auto overflow-x-hidden pr-2 max-h-[calc(90vh-180px)]"
      />

      <DialogModal
        title={
          <div className="flex items-center gap-3">
            <div className="bg-blue-100 p-2 rounded-lg">
              <Icon
                icon="heroicons:calendar-days"
                className="w-5 h-5 text-blue-600"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Reschedule Booking</h3>
              <p className="text-gray-600 text-sm">
                Change the date and time of this booking
              </p>
            </div>
          </div>
        }
        open={showReschedule}
        setOpen={setShowReschedule}
        Child={_renderReschedule}
        className="max-w-2xl"
      />

      <DialogModal
        title={
          <div className="flex items-center gap-3">
            <div className="bg-yellow-100 p-2 rounded-lg">
              <Icon
                icon="heroicons:ticket"
                className="w-5 h-5 text-yellow-600"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Add Discount</h3>
            </div>
          </div>
        }
        open={showAddDiscount}
        setOpen={setShowAddDiscount}
        Child={_renderAddDiscount}
        className="max-w-2xl"
      />

      <DialogModal
        title={
          <div className="flex items-center gap-3">
            <div className="bg-red-100 p-2 rounded-lg">
              <Icon
                icon="heroicons:x-circle"
                className="w-5 h-5 text-red-600"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Cancel Booking</h3>
              <p className="text-gray-600 text-sm">
                Cancel this booking permanently
              </p>
            </div>
          </div>
        }
        open={ShowCancelBooking}
        setOpen={setShowCancelBooking}
        Child={_renderCancelBooking}
        className="max-w-md"
      />

      <DialogModal
        title={
          <div className="flex items-center gap-3">
            <div className="bg-purple-100 p-2 rounded-lg">
              <Icon
                icon="heroicons:document-text"
                className="w-5 h-5 text-purple-600"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Add Notes</h3>
              <p className="text-gray-600 text-sm">
                Add notes or comments to this booking
              </p>
            </div>
          </div>
        }
        open={showNotes}
        setOpen={setShowNotes}
        Child={_renderNotes}
        className="max-w-md"
      />

      <DialogModal
        title={
          <div className="flex items-center gap-3">
            <div className="bg-blue-100 p-2 rounded-lg">
              <Icon
                icon="heroicons:calculator"
                className="w-5 h-5 text-blue-600"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg">Add Tax</h3>
              <p className="text-gray-600 text-sm">
                Apply tax to this booking
              </p>
            </div>
          </div>
        }
        open={showAddTax}
        setOpen={setShowAddTax}
        Child={_renderAddTax}
        className="max-w-2xl"
      />
    </>
  );
};

export default BooingDetails;
